module.exports = __webpack_public_path__ + "img/top_slider_202510_flora.c6019015.jpg";